import { type FC } from "react";

import { clsx } from "clsx";

export type DividerTone = "default" | "muted";

const TONE_STYLE: Record<DividerTone, string> = {
  default: "divider",
  muted: "border-slate-100",
};

export const Divider: FC<{ tone?: DividerTone }> = ({ tone = "default" }) => (
  <hr className={clsx(TONE_STYLE[tone])} />
);
